import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';
import { ITfnState } from './state';

const state = (state: AppState) => state.tfnState;

export const tfn_Form = createSelector(
  state,
  (state: ITfnState) => state.form
);

export const tfn_DataSaved = createSelector(
  state,
  (state: ITfnState) => state.dataSaved
);